module.exports = "<app-header-nav></app-header-nav>\n<!-- begin::Body -->\n<router-outlet></router-outlet>\n<!-- end::Body -->\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/theme.component.html
// module id = ./src/app/theme/theme.component.html
// module chunks = main